var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 41.5,
    stroke: "#FF5151",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0114 26.0006C56.4829 26.013 55.9808 26.2342 55.6149 26.6158L42.029 40.2017L28.443 26.6158C28.2564 26.424 28.0332 26.2715 27.7866 26.1675C27.5401 26.0635 27.2751 26.0101 27.0075 26.0103C26.6098 26.0108 26.2213 26.1299 25.8916 26.3522C25.5618 26.5746 25.3059 26.8902 25.1564 27.2588C25.0069 27.6273 24.9707 28.032 25.0524 28.4213C25.1341 28.8105 25.3299 29.1665 25.6149 29.4439L39.2009 43.0299L25.6149 56.6158C25.423 56.8001 25.2697 57.0208 25.1642 57.2651C25.0586 57.5093 25.0028 57.7722 25.0001 58.0383C24.9974 58.3044 25.0478 58.5683 25.1484 58.8147C25.249 59.061 25.3977 59.2848 25.5858 59.473C25.774 59.6611 25.9978 59.8099 26.2442 59.9105C26.4905 60.011 26.7545 60.0614 27.0206 60.0587C27.2866 60.056 27.5495 60.0003 27.7938 59.8947C28.038 59.7891 28.2588 59.6359 28.443 59.4439L42.029 45.858L55.6149 59.4439C55.7992 59.6359 56.0199 59.7891 56.2642 59.8947C56.5085 60.0003 56.7713 60.056 57.0374 60.0587C57.3035 60.0615 57.5674 60.011 57.8138 59.9105C58.0602 59.8099 58.284 59.6612 58.4721 59.473C58.6603 59.2848 58.809 59.061 58.9096 58.8147C59.0102 58.5683 59.0606 58.3044 59.0579 58.0383C59.0552 57.7722 58.9994 57.5093 58.8938 57.2651C58.7882 57.0208 58.635 56.8001 58.443 56.6158L44.8571 43.0299L58.443 29.4439C58.7341 29.1649 58.934 28.8043 59.0165 28.4097C59.0991 28.015 59.0604 27.6046 58.9056 27.2323C58.7508 26.86 58.4871 26.5432 58.1491 26.3234C57.8111 26.1035 57.4145 25.991 57.0114 26.0006Z",
    fill: "#FF1111",
    fillOpacity: 0.733333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.99b453e92e16cfb85c08985ba198fe3b.svg";
export { ForwardRef as ReactComponent };